import Alpine from 'alpinejs';

// Initialize Alpine.js
window.Alpine = Alpine;
Alpine.start();

// MDB will be available globally via the UMD bundle
// Initialize MDB components when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // Add event listeners for subscription modal buttons
    const subscriptionButtons = document.querySelectorAll('[data-mdb-toggle="modal"][data-mdb-target="#subscriptionModal"]');
    subscriptionButtons.forEach(button => {
        button.addEventListener('click', function() {
            const modalElement = document.getElementById('subscriptionModal');
            if (window.mdb && window.mdb.Modal) {
                const modal = new window.mdb.Modal(modalElement);
                modal.show();
            } else {
                console.error('MDB Modal is not available');
            }
        });
    });
});
